import axios from '@/config/api.request'

export default {
    // 根据团购返利活动主键查询所有推广员
    getPromotersByCryptoGroupRebateId(cryptoGroupRebateId) {
        return axios.request({
            url: '/crypto/group/promoter/promoters',
            method: 'get',
            params: { cryptoGroupRebateId }
        })
    },
}